import { render, staticRenderFns } from "./ItemListInvoice.vue?vue&type=template&id=f466933e&"
import script from "./ItemListInvoice.vue?vue&type=script&lang=js&"
export * from "./ItemListInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports